<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // console.log(123123)
    if (location.href.indexOf("debug") > -1) {
      var new_element = document.createElement("script");
      new_element.setAttribute("type", "text/javascript");
      new_element.setAttribute(
        "src",
        "https://g.alicdn.com/code/lib/vConsole/3.4.0/vconsole.min.js"
      );
      document.body.appendChild(new_element);
      window.onload = function () {
        let vConsole = new window.VConsole();
        console.log(vConsole);
      };
    }
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      /*window.location.href="你的手机版地址";*/
      this.$router.push({ name: "pc_Popup" });
    } else {
      /*window.location.href="你的电脑版地址";    */
      this.$router.push({ name: "pc" });
    }
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue